import { ComponentType } from 'react';
import ErrorBoundary from '~/components/ErrorBoundary';
import { AnyProps } from '~/types';

/**
 * Wraps component in error boundary
 * + wraps whole component so issues in component hooks, logic, etc. will be caught by HOC
 * + error boundary isolated to specific component so reused components don't need to re-add it in parent
 * + readability
 */
export const withErrorBoundary =
  <T extends AnyProps>(WrappedComponent: ComponentType<T>) =>
  (props: T) => (
    <ErrorBoundary>
      <WrappedComponent {...props} />
    </ErrorBoundary>
  );
